module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAMCAYAAAC0qUeeAAAAx0lEQVQoU5WRsQ7BUBSGv8Mg6SRhFg9gkzamJlIewQuIwQtIlw42ae1iEIvRM4jVC+gsZjZGOdLLUEXoTc5w//+79/7nHgFojtUqW7goXTBV2PjSSLz0Ei/SFUoPKKWNjS/yDoeqWTHZOzZ7FdZSZD1xJU408ULVRR/qVTicYLB8HHXslytiEWYGHrahVoHjGebbjzAKNwN/iWHkUevhTnfPGLngf2LkadA8/jPz61BCvQJWNnfm6xC4SCfSQJUgO8E0nIAIwR1P/Uq7P8U7IwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jianjie.png
// module id = Ljd1
// module chunks = 1